var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEye = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0655 6.375C11.0655 7.93981 9.79702 9.20833 8.23221 9.20833C6.66741 9.20833 5.39888 7.93981 5.39888 6.375C5.39888 4.81019 6.66741 3.54167 8.23221 3.54167C9.79702 3.54167 11.0655 4.81019 11.0655 6.375ZM9.64888 6.375C9.64888 7.1574 9.01462 7.79167 8.23221 7.79167C7.44981 7.79167 6.81555 7.1574 6.81555 6.375C6.81555 5.5926 7.44981 4.95833 8.23221 4.95833C9.01462 4.95833 9.64888 5.5926 9.64888 6.375Z",
    fill: "#606474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23221 0C12.1929 0 15.5208 2.70889 16.4644 6.375C15.5208 10.0411 12.1929 12.75 8.23221 12.75C4.27155 12.75 0.943591 10.0411 0 6.375C0.943591 2.70889 4.27155 0 8.23221 0ZM8.23221 11.3333C5.06202 11.3333 2.37523 9.24951 1.47275 6.375C2.37523 3.50049 5.06202 1.41667 8.23221 1.41667C11.4024 1.41667 14.0892 3.50049 14.9917 6.375C14.0892 9.24951 11.4024 11.3333 8.23221 11.3333Z",
    fill: "#606474"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-eye.e786d8a6.svg";
export { ForwardRef as ReactComponent };